import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class CampaignBranchEntity {
  branch?: BranchMiniEntity
  serviceRatio?: number | null
  branchRatio?: number | null
  limitedBranchShareAmount?: number | null
  shareType?: 'Ratio' | 'Amount'
}
